import { env } from '@/main/config'
import { SupabaseEdgeHttpClient } from '@/shared/infra/http'
import { EdgeLinkClubRepository } from '@/modules/auth/infra/repositories'
import type { LinkClub } from '@/modules/auth/use-cases'

export function makeLinkClub(): LinkClub {
  return new EdgeLinkClubRepository(
    new SupabaseEdgeHttpClient(env.edgeFunctionsBaseUrl, async () => env.supabaseAnonKey),
  ).execute
}
